export const CardData = [
  {
    HTML5: "/images/icons/html.svg",
    CSS3: "/images/icons/css.svg",
    Javascript: "/images/icons/javascript.svg",
    jQuery: "/images/icons/jquery.svg",
    Bootstrap: "/images/icons/bootstrap.svg",
    Sass: "/images/icons/sass.svg",
    React: "/images/icons/react.svg",
    Php: "/images/icons/php.svg",
    Nodejs: "/images/icons/nodejs.svg",
    MySQL: "/images/icons/mysql.svg",
    Laravel: "/images/icons/laravel.svg",
    Codeigniter: "/images/icons/codeigniter.svg",
    Java: "/images/icons/java.svg",
    // Springboot: "/images/icons/springboot.png",
    Git: "/images/icons/git.svg",
  },
];
